// @ts-nocheck
import Mustache from 'mustache';
import Immutable from 'immutable';

export default class GridControl {
  constructor() {
    this._pinned = false;
    this._currentData = Immutable.fromJS(null);

    this._container = document.createElement('div');

    this._container.style.width = '250px';
    this._container.style.padding = '10px';
    this._container.style.backgroundColor = 'white';
    this._container.style.margin = '0 10px 10px 0';
    this._container.style.outline = 'none';
    this._container.style.border = '1px solid transparent';
    this._container.style.boxShadow = '0 2px 6px rgba(0, 0, 0, .3)';
    this._container.style.borderRadius = '2px';
    this._container.style.transition = 'all 0.2s ease-in-out';
    this._container.style.display = 'none';

    this._content = document.createElement('div');
    this._content.style.fontSize = '13px';
    this._content.style.color = '#333';
    this._container.appendChild(this._content);

    this._link = document.createElement('a');
    this._link.style.position = 'absolute';
    this._link.style.top = '0';
    this._link.style.right = '0';
    this._link.style.margin = '2px 6px';
    this._link.style.lineHeight = '22px';
    this._link.style.fontSize = '22px';
    this._link.style.textDecoration = 'none';
    this._link.style.color = '#ababab';
    this._link.href = '#';
    this._link.innerHTML = '×';

    this._link.addEventListener('click', (event) => {
      event.preventDefault();
      this.hide();
    });

    this._container.appendChild(this._link);
  }

  get element() {
    return this._container;
  }

  get pinned() {
    return this._pinned;
  }

  setData(data, template, format) {
    if (this._pinned && format !== 'full') {
      return;
    }

    const newData = Immutable.fromJS(data);

    if (data == null) {
      this._currentData = newData;
      this.hide();
      return;
    }

    if (format !== 'full' && Immutable.is(this._currentData, newData)) {
      return;
    }

    this._currentData = newData;
    const d = {};
    d[`__${format}__`] = true;
    const html = Mustache.render(template, Object.assign(d, data));
    this._content.innerHTML = html;
    this._container.style.display = 'block';

    if (format === 'full') {
      this._pinned = true;
      this._link.style.display = 'inline';
    } else {
      this._link.style.display = 'none';
    }
  }

  hide() {
    this._currentData = Immutable.fromJS(null);
    this._pinned = false;
    this._content.innerHTML = '';
    this._container.style.display = 'none';
  }
}
